import { useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { ReactComponent as Close } from "./close.svg";

function Conditions() {
  const navigate = useNavigate();
  const hasHandled = useRef(false);

  const goToMain = () => {
    navigate("/");
  };

  const goToShop = () => {
    navigate("/shop");
  };

  return (
    <>
      <div className="root">
        <div className="logoContainer">
          <div className="logoSmaller" onClick={() => goToMain()}>
            <b>kfOne</b>
          </div>
          <div className="underLogoSmaller" onClick={() => goToMain()}>
            <b>Killing Floor 1 Server</b>
          </div>
        </div>

        <div className="purchaseDiv">
          <div className="titleText">
            <b>Terms and Conditions</b>
          </div>
          <div className="helpDescription">
            <b>
              Currently the services are free. The main condition is to enjoy
              and have fun!
            </b>
          </div>
          <div>
            <div className="termsBox">
              <div className="wholeText">
                <div className="listText">
                  <Close className="closeMarkForm" onClick={goToShop}></Close>
                </div>
                <div className="perkDesc">Currently the services are free.</div>

                <div className="perkDesc">
                  The main condition is to enjoy and have fun!
                </div>

                <div className="perkDesc"></div>
                <div className="wholeText">
                  <p></p>
                  <p>info@kfone.lt</p>
                </div>
              </div>
            </div>
            <footer>
              <p>© {new Date().getFullYear()}</p>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
}

export default Conditions;
